<template >
  <div id="user-info-card">
    <div class="user-info-card-info mb-5">
      <div class="info-section">
        <div
          class="section-header"
          :style="isFreeUser ? 'display: flex; align-items: center; justify-content: space-between;' : ''"
        >
          <h2>Payment</h2>
          <TerminalBasicButton
            v-if="isFreeUser"
            v-on:terminalBasicButtonClicked="upgradePlan"
            buttonText="Go Premium"
            color="unibit-yellow"
          ></TerminalBasicButton>
          <!-- To do change card in stripe -->
          <TerminalBasicButton
            id="activate"
            data-toggle="modal"
            data-target="#UpdateCard"
            buttonText="Update"
            color="unibit-yellow"
          ></TerminalBasicButton>
        </div>
        <div class="card-section" v-if="!isFreeUser">
          <div class="card-info-section">
            <img
              id="cardImg"
              :src="require(`@/assets/imgs/card_icons/${cardBrandLower}.png`)"
              alt
              v-if="cardBrandLower"
            />
            <div style="margin-left:1.5rem">
              <p id="cardTitle">{{cardBrand}} **** {{cardLastDigits}}</p>
              <p class="card-info">Expires at {{cardExpDate}}</p>
              <p class="card-info">Funding: {{cardInfo.funding}}</p>
              <p class="card-info">ZIP Code: {{cardInfo.addressZip}}</p>
            </div>
          </div>
        </div>
        <!-- <div class="card-cutomize-section">
            <p>Add another card </p>
            <v-icon name='plus' style="width:24px"></v-icon>
        </div>-->
      </div>
      <div class="info-section">
        <div class="section-header">
          <h2>Latest Invoice</h2>
          <div class="place-holder"></div>
        </div>
        <documentation-table
          v-if="invoiceDataSet"
          :columns="invoiceCol"
          :data="invoiceDataSet"
          title
          description
        ></documentation-table>
      </div>
    </div>

    <Modal id="UpdateCard" title="Update Payment Method" background="white">
      <div slot="body">
        <div style="margin-top: 2.375rem;">
          <label class="md-form mb-0">
            <!-- <label data-error="wrong" data-success="right" for="paid-stripe-card">Credit or debit card</label> -->
            <div class="form-control" style="border: solid 1px;  width: 535px;" ref="card"></div>
            <div id="card-errors" role="alert"></div>
            <p class="error-message" id="card-errors" role="alert">{{card_error || "&nbsp;"}}</p>
          </label>
        </div>
        <div
          style="margin-top:3rem; text-align:center;display: flex; justify-content: space-evenly;"
          class="download-button-group"
        >
          <TerminalBasicButton
            v-if="!updating"
            buttonText="Comfirm"
            v-on:terminalBasicButtonClicked="updateCard"
          ></TerminalBasicButton>
          <TerminalBasicButton
            v-if="!updating"
            buttonText="Cancel"
            data-dismiss="modal"
            color="unibit-transparent"
          ></TerminalBasicButton>
          <PulseLoader color="#f5a623" v-else></PulseLoader>
          <!-- <p class="footer-message" data-dismiss="modal">Give it a second thought</p> -->
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Modal from "@/components/base/modal";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import TerminalBasicButton from "@/components/base/terminal-basic-button";
import globalConstants from "@/utils/global-constants.js";
import DocumentationTable from "@/components/table/documentation-table";

// Step 1: import stripe
let stripe = Stripe(globalConstants.STRIPE_KEY);
let paymentRequest = null;

// Step 2: Create an instance of Elements.
let elements = stripe.elements();
// Step 3: Create paymentRequestButton Element
let prButton = null;
// Step 4: Create input field for card
let card = null;

export default {
  props: {
    label: {
      type: String,
      default: "label"
    }
  },

  components: {
    Modal,
    PulseLoader,
    TerminalBasicButton,
    DocumentationTable
  },

  mounted() {
    this.initStripeCard(1);
  },

  data() {
    return {
      card_error: "",
      updating: false
    };
  },

  computed: {
    cardBrand() {
      return this.cardInfo ? this.cardInfo.brand : "";
    },

    cardBrandLower() {
      let brand = this.cardInfo.brand ? this.cardInfo.brand : "";
      return brand.toLowerCase();
    },

    cardLastDigits() {
      return this.cardInfo ? this.cardInfo.last4 : "";
    },

    cardExpDate() {
      if (!this.cardInfo) return " ";
      const month = this.cardInfo.expMonth;
      const year = this.cardInfo.expYear;
      return month + "/" + year;
    },

    invoiceBeginDate() {
      if (!this.invoice) return " ";
      return new Date(this.invoice.created * 1000).toLocaleDateString("en-US");
    },

    amountPaid() {
      if (!this.invoice) return " ";
      let amount = this.invoice.amountPaid;
      amount = amount / 100;
      return "$" + amount;
    },

    enddate() {
      const time = this.subPeriodEnddate * 1000;
      return new Date(time).toLocaleDateString("en-US");
    },

    /**
     * return true if user role is free
     */
    isFreeUser() {
      return this.getWindowLocalStorage("role") === "free";
    },

    invoiceDataSet() {
      return this.invoice.map(item => {
        return {
          planName: item.plan || "No Name",
          period:
            new Date(item.start * 1000).toLocaleDateString("en-US") +
            " - " +
            new Date(item.end * 1000).toLocaleDateString("en-US"),
          billingCycle: item.interval,
          amount: item.amount
        };
      });
    },

    invoiceCol() {
      return [
        { id: 0, key: "planName", label: "Plan Name" },
        { id: 1, key: "period", label: "Period" },
        { id: 2, key: "billingCycle", label: "Billing Cycle" },
        { id: 3, key: "amount", label: "Amount" }
      ];
    },

    ...mapState({
      cardInfo: state => state.UserService.cardInfo,
      loggedIn: state => state.UserService.idToken !== null,
      invoice: state => state.UserService.billingInvoice,
      plan: state => state.UserService.userPlan,
      subPeriodEnddate: state => state.UserService.subPeriodEnddate
    })
  },
  methods: {
    upgradePlan() {
      this.$router.replace("/upgrade");
    },

    updateCard() {
      stripe.createToken(card).then(result => {
        // Inform the user if there was an error.
        // Otherwise, Send the token to our backend server.
        if (result.error) {
          this.card_error = result.error.message;
          this.$store.dispatch("notify", {
            info: result.error.message,
            type: "error"
          });
        } else {
          const stripeToken = result.token.id;
          const email = this.getWindowLocalStorage("email");
          this.updating = true;
          this.$store
            .dispatch("updateUserCard", { email, stripeToken })
            .then(res => {
              const cardInfo = res.data;
              this.updating = false;
              this.$store.commit("setCardInfo", cardInfo);
              this.$store.dispatch("notify", {
                info: "Update Card Successful",
                type: "success"
              });
              $("#UpdateCard").modal("hide");
            })
            .catch(err => {
              console.log(err);
              this.updating = false;
              $("#UpdateCard").modal("hide");
              let message = err.response.data.message;

              if (message.startsWith("Your card"))
                message = "Your card information is incorrect !";
              this.$store.dispatch("notify", { info: message, type: "error" });
            });
        }
      });
    },

    initStripeCard(price) {
      // Step 1: Check the availability of the Payment Request API first.
      if (paymentRequest == null) {
        paymentRequest = stripe.paymentRequest({
          country: "US",
          currency: "usd",
          total: {
            label: "Institutional",
            amount: price * 100 // cents
          },
          requestPayerName: true,
          requestPayerEmail: true
        });
      }

      // ***always show prButton for sign up***
      let that = this;
      if (prButton == null) {
        prButton = elements.create("paymentRequestButton", {
          paymentRequest: paymentRequest
        });
      }

      paymentRequest
        .canMakePayment()
        .then(function(result) {
          // console.log("canMakePayment() result is: ", result);
          // if (result) {
          prButton.mount(that.$refs.paymentRequestButton);
          // } else {
          //   document.getElementById("paymentRequestButton").style.display = "none";
          // }
        })
        .catch(function(error) {
          console.log("can make payment, error is: ", error);
        });

      // Step 2: set card style
      let style = {
        base: {
          color: "#32325d",
          fontFamily: "sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      // Create an instance of the card Element.
      if (card == null) {
        card = elements.create("card", { style: style });
      }
      // Add an instance of the card Element into the `card-element` <div>.
      console.log("mount card!!!");
      card.mount(this.$refs.card);
      // Handle real-time validation errors from the card Element.
      card.addEventListener("change", event => {
        event.error
          ? (this.card_error = event.error.message)
          : (this.card_error = "");
      });
    }
  }
};
</script>


<style lang="css" scoped>
* {
  font-family: Raleway;
  font-size: 0.875rem;
  /* font-weight: bold; */
  color: #656666;
  letter-spacing: 0.56px;
}

#user-info-card {
  background-color: white;
  height: 100%;
  overflow: auto;
}

.card-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.card-info-section {
  display: flex;
  flex-wrap: wrap;
}

#cardImg {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

#cardTitle {
  letter-spacing: 0.56px;
  font-weight: bold;
}

.card-info {
  font-weight: normal;
  letter-spacing: 0.56px;
}

.user-info-card-info {
  padding: 1rem;
}

.info-section {
  margin-bottom: 1rem;
}

.info-section h2 {
  font-size: 1rem;
  /* padding: 1rem 1.5rem; */
  margin: 0px;
  font-weight: 600;
}

.card-cutomize-section {
  margin-top: 2px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.icon-plus {
  margin-top: 1px;
  margin-left: 2px;
}

.update-input {
  border: 0;
  outline: 0;
  background: transparent;
}

.info-section > div {
  background-color: white;
  padding: 1rem 1.5rem;
}

.section-header {
  padding-bottom: 0 !important;
  margin-bottom: 2px;
  border-bottom: solid 0.4px rgba(151, 151, 151, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-header p {
  background-color: white;
  letter-spacing: 0.59px;
  padding: 1rem;
}

.invoice-table > div {
  text-align: center;
}

.place-holder {
  height: 2.5rem;
}

.StripeElement--focus {
  border-color: #f5a623 !important;
}

@media only screen and (min-width: 992px) {
  * {
    font-size: 1rem;
    letter-spacing: 0.47px;
  }
  #user-info-card {
    padding: 3rem 45px;
  }
  #cardImg {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/payment-info-card.vue